/**
 * K-452: Schweizer Rechtschreibung für Belege und Mails von Agenturen in der Schweiz und in Liechtenstein (Sprache de-CH, de-LI):
 * kein „ß“ (immer „ss“), „Schadenersatz“ statt „Schadensersatz“. Dieselbe Regel wie schweizerisch() der Oberfläche und der
 * Verträge, jetzt auch für Rechnungs-PDF, Mahnschreiben und Mails (Betreff und Text).
 */
export function isSwissGerman(locale: string | null | undefined): boolean {
  return /^de-(CH|LI)$/i.test(locale?.trim() ?? "");
}

export function swissSpelling(text: string): string {
  return text.replace(/Schadensersatz/g, "Schadenersatz").replace(/ß/g, "ss");
}

/**
 * Wendet swissSpelling auf alle Texte einer Struktur an: Zeichenketten, Listen, einfache Objekte und Funktionen, die Texte
 * liefern (Textbausteine mit Platzhaltern). Andere Werte (Bilder, Zahlen, Datumsobjekte) bleiben unverändert; `skip` nennt
 * Schlüssel, die unverändert bleiben (z. B. der QR-Zahlteil, dessen Daten maschinenlesbar sind).
 */
export function swissDeep<T>(value: T, skip: readonly string[] = []): T {
  const walk = (v: unknown): unknown => {
    if (typeof v === "string") return swissSpelling(v);
    if (typeof v === "function") {
      const f = v as (...a: unknown[]) => unknown;
      return (...a: unknown[]) => walk(f(...a));
    }
    if (Array.isArray(v)) return v.map(walk);
    if (v && typeof v === "object" && Object.getPrototypeOf(v) === Object.prototype) {
      const out: Record<string, unknown> = {};
      for (const [k, x] of Object.entries(v)) out[k] = skip.includes(k) ? x : walk(x);
      return out;
    }
    return v;
  };
  return walk(value) as T;
}
